export const SYNC_ESPERIENZA = 'SYNC_ESPERIENZA';

export function syncEsperienza(path) {
  return {
    type: SYNC_ESPERIENZA,
    request: {
      op: 'get',
      path: `${path}/@sync-esperienza`,
    },
  };
}
